export const STRINGS_REGISTROSFITOSSANITARIOS = {
    NAV_REGISTROS_FITOSSANITARIOS: "Requisitos Fitossanitários",
    NAV_REGISTRO_REGISTROS_FITOSSANITARIOS: "Registros",

    SEARCH_REGISTROS_FITOSSANITARIOS: "Consulta de Requisitos Fitossanitários",
    REGISTER_REGISTROS_FITOSSANITARIOS: "Cadastro de Requisitos Fitossanitários",
    EDITION_REGISTROS_FITOSSANITARIOS: "Edição de Requisitos Fitossanitários",

    EDITION_REGISTER_CONFIRMATION_CANCEL: "Todos os dados informados serão perdidos. Tem certeza que deseja cancelar?",
    EDITION_TITLE_CONFIRMATION: "Tem certeza?",
    CONFIRM_LEFT_EDITION: "Sim, voltar",
    CANCEL_LEFT_EDITION: "Não, permanecer",

}